import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {UIGameMechanic} from '../UIGameEventController'
import {UIGameManager} from '../UIGameManager'
import {UIGamePlayerInformationArrayView} from './UIGamePlayerInformationArrayView'
import {UIGamePlayerInformationView} from './UIGamePlayerInformationView'

export abstract class UIGamePlayerInformationArrayController implements UIGameMechanic {
    protected readonly uiGameManager: UIGameManager
    private playerInformationArrayViews: UIGamePlayerInformationArrayView[] = []

    constructor(uiGameManager: UIGameManager) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        this.initPlayerInformationArrayViews()
    }

    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.CanvasResized: this.initPlayerInformationArrayViews(); break
            default: break
        }
    }

    private initPlayerInformationArrayViews() {
        this.playerInformationArrayViews.forEach((view) => view.destroy())
        this.playerInformationArrayViews = []

        for(const playerInformation of this.uiGameManager.playersController.playerInformationViews) {
            this.playerInformationArrayViews.push(this.createPlayerInformationArrayView(playerInformation))
        }
    }

    protected abstract createPlayerInformationArrayView(playerInformation: UIGamePlayerInformationView): UIGamePlayerInformationArrayView
}
